var $8828a5b7b3c88b17$exports = {};
$8828a5b7b3c88b17$exports = {
    "actions": `A\xe7\xf5es`,
    "hideButtonLabel": `Mostrar menos`,
    "noTags": `Nenhum`,
    "showAllButtonLabel": (args, formatter)=>`Mostrar tudo (${formatter.number(args.tagCount)})`
};


export {$8828a5b7b3c88b17$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
